<template>
  <div class="ClientsTableHeader">
    <el-table
      :data="clients"
      border
      :height="tableHeight"
      class="ClientsTable"
      header-row-class-name="ClientsTable-HeaderRow"
      header-cell-class-name="ClientsTable-HeaderCell"
      cell-class-name="ClientsTable-Cell"
    >
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="id" label="得意先コード" />
      <el-table-column prop="address" label="住所" />
      <el-table-column label="" align="center">
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="_onClickUserMaintenance(scope.row)"
          >
            ユーザーの管理
          </el-button>
          <el-button
            size="small"
            @click="_onClickOrderCustomField(scope.row)"
          >
            自由項目の管理
          </el-button>
          <el-button
            size="small"
            @click="_onClickUserProductsManagement(scope.row)"
          >
            商品の管理
          </el-button>
        </template>
      </el-table-column>
      <Infinite-loading
        slot="append"
        @infinite="infiniteLoaderHandler"
        force-use-infinite-wrapper=".el-table__body-wrapper"
      >
        <span slot="no-more"></span>
        <span slot="no-results"></span>
      </Infinite-loading>
    </el-table>
  </div>
</template>

<script>
import UsecaseFactory from "@/usecases/usecase.factory.js";
import InfiniteLoading from "vue-infinite-loading";
import { apiErrorHandler } from "@/services/apiErrorHandler";

const userUsecase = UsecaseFactory.create("user");

export default {
  components: { InfiniteLoading },
  data () {
    return {
      clients: [],
      searchOptions: {},
      requestClients: 30,
      loadedClients: 0,
      infiniteLoaderState: {},
      loadingView: {},
      tableHeight: window.innerHeight - (63 + 84), // ウインドウの高さからヘッダーと検索フォーム分の高さを引く
    };
  },
  async created () {
    this.loadingView = this.$loading();
    document.getElementById("app").style.overflow = "hidden";
  },
  watch: {},
  destroyed () {
    document.getElementById("app").style.overflow = "inherit";
  },
  async mounted () {},
  methods: {
    // infinite scroll handler
    async infiniteLoaderHandler ($state) {
      this.infiniteLoaderState = $state;

      try {
        await this.loadNextClients();
      } catch (err) {
        apiErrorHandler(this, err);
        this.infiniteLoaderState.complete();
      } finally {
        this.loadingView.close();
      }
    },
    async loadNextClients () {
      const clientGroups = await userUsecase.getClientGroups({
        ...this.searchOptions,
        first: this.requestClients,
        offset: this.loadedClients,
      });

      this.clients.push(...clientGroups);
      this.loadedClients += this.requestClients;

      if (clientGroups.length < this.requestClients) {
        this.infiniteLoaderState.complete();
      } else {
        this.infiniteLoaderState.loaded();
      }
    },
    async initClients (options) {
      this.loadingView = this.$loading();
      this.searchOptions = options;
      this.clients = [];
      this.loadedClients = 0;
      this.infiniteLoaderState.reset();
    },
    _onClickUserMaintenance (clientGroup) {
      const { $router } = this;
      let clientID = clientGroup.id;
      this.$store.commit("user/setClientsGroup", clientGroup);
      $router.push({ name: "admin/clients/users", params: { clientID } });
    },

    /**
     * [_onClickOrderCustomField description]
     * @param   {[type]}  clientGroup  [clientGroup description]
     */
    _onClickOrderCustomField (clientGroup) {
      const {
        $router,
        $store,
      } = this;
      const clientID = clientGroup.id;

      $store.commit("user/setClientsGroup", clientGroup);
      $router.push({
        name: "admin/clients/order-custom-field",
        params: { clientID },
      });
    },
    _onClickUserProductsManagement (user) {
      const { $router } = this;
      let clientID = user.id;
      this.$store.commit("user/setClientsGroup", user);
      $router.push({ name: "admin/clients/productsManagement", params: { clientID } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.ClientsTable {
  width: 100%;
}
::v-deep .ClientsTable-HeaderCell {
  text-align: center;
}
::v-deep .ClientsTable-Cell {
  text-align: left;
}
@media (min-width: 767px) {
  ::v-deep .ClientsTable-Cell .cell {
    margin-left: 1.5rem;
  }
}
@media (max-width: 768px) {
  ::v-deep .ClientsTable-Cell .cell {
    margin-left: 0.5rem;
  }
}
::v-deep .el-table th {
  background-color: $background-gray-base !important;
}
</style>
